import React from 'react';

// import tracking
import { track, TRACKING_EVENTS } from 'js/utils/tracking';

const navItems = [
  {
    id: 'teaser',
    label: 'Watch teaser',
    type: 'video',
  },
  {
    id: 'downloads',
    label: 'Wallpapers',
    type: 'downloads',
  },
  {
    id: 'Games',
    label: 'Games',
    type: 'external',
    url: 'https://www.bluey.tv/play/',
  },
  {
    id: 'news',
    label: 'News',
    type: 'external',
    url: 'https://bluey.tv/blog/movie-news/',
  },
  {
    id: 'more_bluey',
    label: 'More',
    type: 'external',
    url: 'https://bluey.tv/',
  },
];

import SvgBlueyLogo from 'js/components/svg/Svg.bluey-logo';

const HeaderNavLinks = ({ className = '', onItemClick = () => {}, toggleModal }) => {
  return (
    <div className={`header-nav__links ${className}`.trim()}>
      {navItems.map((item) => {
        const { type } = item;
        if (type == 'external') {
          return (
            <a
              href={item.url}
              target="_blank"
              rel="noreferrer"
              key={item.id}
              onClick={() => {
                onItemClick();
                track(TRACKING_EVENTS.CLICK_NAVIGATION_HEADER.id, {
                  item_name: item.label,
                  item_link: item.url,
                });
              }}
            >
              <button className={`header-nav__link${item.isActive ? ' header-nav__link--active' : ''}`} type="button">
                {item.id == 'more_bluey' ? (
                  <div className="with-logo">
                    {item.label}
                    <SvgBlueyLogo />
                  </div>
                ) : (
                  <span>{item.label}</span>
                )}
              </button>
            </a>
          );
        } else {
          return (
            <button
              key={item.id}
              className={`header-nav__link${item.isActive ? ' header-nav__link--active' : ''}`}
              type="button"
              onClick={() => {
                toggleModal(item.type);
                onItemClick();
                track(TRACKING_EVENTS.CLICK_NAVIGATION_HEADER.id, {
                  item_name: item.label,
                  item_link: `${item.label} popup overlay`,
                });
              }}
            >
              {item.label}
            </button>
          );
        }
      })}
    </div>
  );
};

export default HeaderNavLinks;
